import _ from 'lodash';
import {
  AnalyticsPageView,
  AnalyticsProvider,
} from '@nerdwallet/seo-analytics';
import { usePathname } from 'next/navigation';

export const AnalyticsWrapper = ({
  children,
  preloadedState,
}: {
  children: React.ReactNode;
  preloadedState: any;
}) => {
  const pathname = usePathname();
  const pageConfig = _.filter(
    preloadedState?.builder?.flatOutline,
    (component) => component.type === 'Page'
  )[0];
  const contentId = pageConfig?.contentId;

  return (
    <AnalyticsProvider>
      <AnalyticsPageView
        name="page_view"
        properties={{
          path: pathname,
        }}
        contentSource="wp"
        contentId={contentId}
      >
        {children}
      </AnalyticsPageView>
    </AnalyticsProvider>
  );
};
